import { defaultTheme, type ModalTheme } from '@medly-components/theme';
import colors from './colors';

export const modal: ModalTheme = {
    ...defaultTheme.modal,
    scrollbarThumbColor: colors.grey[500],
    padding: {
        header: {
            desktop: '4.8rem 5.6rem 1.6rem 4.8rem',
            mobile: '2.4rem 5.6rem 1.6rem 2.4rem'
        },
        content: {
            desktop: '0.8rem 4.8rem 2.4rem',
            mobile: '0.8rem 2.4rem 2.4rem'
        },
        actions: {
            desktop: '2.4rem 4.8rem 4.8rem',
            mobile: '1.2rem 2.4rem'
        }
    }
};
